import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { LineReveal, FadeUp } from "@/components/site/Reveal";
import { waLink } from "@/data/site";

export const CtaBand = () => (
  <section className="px-6 py-24" data-testid="cta-section">
    <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[36px] border border-[#39FF14]/20 px-8 py-20 md:px-16 md:py-28"
      style={{ background: "radial-gradient(700px 400px at 85% 0%, rgba(57,255,20,0.18), transparent 60%), radial-gradient(600px 400px at 0% 100%, rgba(59,130,246,0.25), transparent 60%), #050B1A" }}>
      <p className="eyebrow mb-6">Ready when you are</p>
      <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[0.95] max-w-4xl">
        <LineReveal lines={["Send your list.", <span key="b" className="neon-text">Get a price in minutes.</span>]} />
      </h2>
      <FadeUp delay={0.2} className="mt-10 flex flex-wrap gap-4">
        <a href={waLink("Hi Rama Electricals, here is my material list for a quote:")} target="_blank" rel="noreferrer" className="btn-neon" data-testid="cta-whatsapp-btn">
          <MessageCircle size={18} /> WhatsApp your list
        </a>
        <Link to="/contact" className="btn-ghost" data-testid="cta-contact-btn">Visit the store <ArrowUpRight size={18} /></Link>
      </FadeUp>
      <svg className="orbit-ring absolute -right-40 -bottom-40 w-[520px] h-[520px] opacity-50 pointer-events-none" viewBox="0 0 200 200" aria-hidden="true">
        <circle cx="100" cy="100" r="90" fill="none" stroke="rgba(57,255,20,0.25)" strokeDasharray="1 5" />
        <circle cx="100" cy="100" r="60" fill="none" stroke="rgba(59,130,246,0.3)" />
        <circle cx="190" cy="100" r="3" fill="#39FF14" />
      </svg>
    </div>
  </section>
);
